/**
 * All valid values for the `messageType` of Inline Message Components.
 */
export type MessageType = 'info' | 'success' | 'warning' | 'error';

/**
 * Default value for `messageType` of Inline Message Components.
 */
export const DEFAULT_INLINE_MESSAGE_TYPE: MessageType = 'warning';
